if (!customElements.get('sparky-shuffle')) {
  class SparkyShuffle extends HTMLElement {
    constructor() {
      super();
    }

    init() {
      this.locale = this.dataset.locale == 'false' ? false : this.dataset.locale   
    }

    
    connectedCallback() {      

      document.addEventListener('DOMContentLoaded', () => {
        this.init();
      });
      
      this.addEventListener('click', e => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const {
          action,
          productHandle,
          colorName, 
          colorCode
        } = clickedElement.dataset;
        
        switch (action) {
          case 'product-select':
            window.dispatchEvent(new CustomEvent('productForm:colorChange', { detail: { colorName, colorCode }}));
            if (this.closest('custom-modal')) {
              this.querySelectorAll('[data-section]').forEach((sectionWrapper) => {
                const sectionId = sectionWrapper.dataset.section;
                const loader = document.querySelector(`template[data-loader="${sectionId}"]`)?.cloneNode(true);
                const sectionInnerHTML = sectionWrapper.innerHTML;
                sectionWrapper.innerHTML = `
                  <intersection-loader 
                    data-url="${this.locale ? `/${this.locale}` : `` }/products/${productHandle}"
                    data-section-id="${sectionId}"
                    class="${sectionWrapper.classList}"
                  >${loader ? loader.innerHTML : sectionInnerHTML}</intersection-loader>
                `;
              });
              return;
            }
            
            const canonicalProductUrl = document.querySelector('[data-product-canonical]');
            if (canonicalProductUrl) {
              canonicalProductUrl.href = Object.assign(new URL(canonicalProductUrl.href), { pathname: `/products/${productHandle}` }).toString();
            }
            history.replaceState('', '', `${this.locale ? `/${this.locale}` : `` }/products/${productHandle}`);
            document.querySelectorAll('[data-section]').forEach((sectionWrapper) => {
              const sectionId = sectionWrapper.dataset.section;
              const loader = document.querySelector(`template[data-loader="${sectionId}"]`)?.cloneNode(true);
              const sectionInnerHTML = sectionWrapper.innerHTML;
              sectionWrapper.innerHTML = `
                <intersection-loader 
                  data-url="${this.locale ? `/${this.locale}` : `` }/products/${productHandle}"
                  data-section-id="${sectionId}"
                  class="${sectionWrapper.classList}"
                >${loader ? loader.innerHTML : sectionInnerHTML}</intersection-loader>
              `;
            });
            
             // keeps the price up to date with actual selection across section loads
            const observer = new MutationObserver(observerCallback.bind(this));
            observer.observe(this, { childList: true, subtree: true });
            
            function observerCallback(mutationList) {
              for (const mutation of mutationList) {
                if (mutation.type === 'childList') {
                  if (mutation.target.dataset.section === "product-panel-header") {
                    poll(() => {
                        return this.querySelector('product-form:not(:has(intersection-loader))');
                      }, 10000, 150)
                        .then(() => {
                          this.querySelector('product-form').updatePriceDisplay()
                        });
                  }
                }
              }
            }
          break;

          case 'option-choice':
            // Uncomment below to handle checking swym icons on size change.
            // poll(() => {
            //   return wishlist_items;
            // }, 10000, 150).then(() => {
            //   setTimeout(() => {
            //     const variant_id = Number(this.querySelector('[data-main-select]').value);
            //     const variant_is_on_wishlist = wishlist_items.find(item => item.epi === variant_id);
            //     const wishlist_icons = this.querySelectorAll('[data-wishlist-action');

            //     wishlist_icons.forEach(icon => {
            //       const wishlist_icon = icon.querySelector('svg');

            //       wishlist_icon.classList.remove('heart-icon-soft-red');
            //       wishlist_icon.classList.add('heart-icon-white');

            //       if (variant_is_on_wishlist) {
            //         wishlist_icon.classList.add('heart-icon-soft-red');
            //         wishlist_icon.classList.remove('heart-icon-white');
            //       }
            //     });
            //   }, 0);
            // }); 
          break;

          default:
          break;
        }
      });
    }
  }
  
  customElements.define('sparky-shuffle', SparkyShuffle);
}